const OfferPriorityEnum = Object.freeze({
  LOWEST: -2,
  LOW: -1,
  DEFAULT: 0,
  HIGH: 1,
  HIGHEST: 2
});

export default OfferPriorityEnum;
